import React, { useEffect, useState } from "react";
import { Breadcrumb, Col, Form, Row } from "react-bootstrap";
import { toast, ToastContainer, Zoom } from "react-toastify";
import userService from "../../app/services/user.service";
import Card from "../../UI/Card/Card";
import Graybg from "../../UI/Graybg";
import Input from "../../UI/Input/Input";
import Loader from "../../UI/loader/loader";
import Modals from "../../UI/Modals/Modals";
import SecBTN from "../../UI/SecBTN";
import Select from "../../UI/Select/Select";
// import DataTable from './DataTable/Table'
import DataTable from './DataTable/Table'
import Toast from "../../UI/Toast/Toast";

const EditSubTopic = () => {
  const x = JSON.parse(localStorage.getItem("user"));
  const [showPopUp, setShowPopUp] = useState(false)
  const [loading, setLoading] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [noData, setNoData] = useState(false);
  const [subjectList, setSubjectList] = useState([])
  const [topicList, setTopicList] = useState([])
  const [subTopicList, setSubTopicList] = useState([])
  const [modalSelectedSub, setModalSelectedSub] = useState('')
  const [selectedSubject, setSelectedSubject] = useState('')
  const [selectedTopic, setSelectedTopic] = useState('')
  const [modalTopicList, setModalTopicList] = useState([])
  const [addModalData, setAddModalData] = useState({
    sub_topic_name: "",
    topic_id: "",
    user_id: '',
    sub_topic_sequence: '',
  });
  const [selectedStatus, setSelectedStatus] = useState('');
  useEffect(() => {
    setLoading(true)
    userService.getSubjectList()
      .then((data) => {
        setSubjectList(data.data.data);
      })
      .then(() => setLoading(false))
      .catch((err) => {
        setLoading(false)
        console.log(err);
      })
  }, []);
  const selectSubHandler = (e) => {
    setSelectedSubject(e.target.value);
    setSelectedTopic('');
    setSubTopicList([]);
    setNoData(false);

    setLoading(true);

    userService.getTopicListBySid(e.target.value)
      .then((data) => {
        setTopicList(data.data.data);
      })
      .finally(() => setLoading(false));
  };


  const modalSubSelector = (e) => {
    setLoading(true)
    setModalSelectedSub(e.target.value)
    setAddModalData(prev => {
      return {
        ...prev,
        topic_id: ''
      }
    })
    userService.getTopicListBySid(e.target.value)
      .then((data) => {
        setModalTopicList(data.data.data);
      })
      .then(() => setLoading(false))
      .catch((err) => {
        setLoading(false)
        console.log(err.response.data.info);
        if (err.response.data.info) {
          setModalTopicList([])
          setAddModalData(prev => {
            return {
              ...prev,
              topic_id: ''
            }
          })
          toast.error(err.response.data.message)
        }
      })
  }
  const selectTopicHandler = (e) => {
    setSelectedTopic(e.target.value);
  };
  const searchHandler = () => {
    if (!selectedTopic) {
      toast.error("Please select a topic");
      return;
    }

    setLoading(true);
    setNoData(true);

    userService.getSubTopicByTid(selectedTopic)
      .then((data) => {
        let datas = data.data.data.map((item, i) => ({
          index: i + 1,
          ...item,
        }));

        if (selectedStatus !== '') {
          datas = datas.filter(
            (item) => String(item.status) === String(selectedStatus)
          );
        }

        setSubTopicList(datas);
      })
      .catch((err) => {
        console.log(err);
        setSubTopicList([]);
        toast.error("Something Went Wrong !!");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const reloadDataFn = () => {
    setTimeout(() => {
      userService.getSubTopicByTid(selectedTopic)
        .then((data) => {
          const datas = data.data.data.map((item, i) => {
            return { index: i + 1, ...item }
          })
          setSubTopicList(datas);
        })
        .catch((err) => {
          console.log(err.response.data.info);
          if (err.response.data.info) {
            toast.error(err.response.data.message)
          }
        })
    }, 500);
  }
  const activationHandler = (status, SubTopicId) => {
    setLoading(true)
    let body;
    let msg;
    if (status == 1) {
      body = {
        "sub_topic_id": SubTopicId,
        "status": 0
      };
      msg = "Subtopic Deactivated Successfully."
    } else {
      body = {
        "sub_topic_id": SubTopicId,
        "status": 1
      };
      msg = "Subtopic Activated Successfully.";
    }
    userService.updateSubTopicStatus(body, SubTopicId)
      .then((data) => {
        console.log(data);
        toast.success(msg)
      })
      .then(() => setLoading(false))
      .catch((err) => {
        setLoading(false)
        console.log(err);
      })
    // 
    reloadDataFn();
  };
  const updateHandler = (data) => {
    const body = {
      sub_topic_id: data.sub_topic_id,
      sub_topic_name: data.sub_topic_name,
      topic_id: +selectedTopic,
      user_id: +x?.data?.user?.user_id,
      sub_topic_sequence: +data.sub_topic_sequence !== 0 ? +data.sub_topic_sequence : null,
      is_printed: data.is_printed,
      status: data.status,
    };
    userService.updateSubTopic(body, data.sub_topic_id)
      .then((data) => {
        console.log(data);
        toast.success("Sub-topic Updated Successfully")
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something Went Wrong !!")
      });
    reloadDataFn();
  }
  const addTopicPopup = () => {
    setShowPopUp(true)
  };
  const hideHandler = () => {
    setShowPopUp(false)
  };
  const onAddSubTopic = () => {
    setBtnLoading(true)
    const body = {
      sub_topic_name: addModalData.sub_topic_name,
      topic_id: +addModalData.topic_id,
      user_id: x?.data?.user?.user_id,
      sub_topic_sequence: +addModalData.sub_topic_sequence,
      is_printed: 0,
      status: 1,
    };
    userService.createSubTopic(body, +addModalData.topic_id)
      .then((data) => {
        console.log(data);
        toast.success("Sub-topic Added Successfully.")
        setBtnLoading(false)
        setShowPopUp(false)
        setAddModalData({
          sub_topic_name: "",
          topic_id: "",
          user_id: "",
          sub_topic_sequence: "",
        });
      })
      .catch((err) => {
        setBtnLoading(false)
        console.log(err);
        toast.error("Something Went Wrong !!")
      });
    //reloadDataFn();
  };
  const addSubTopicPopup = () => {
    setShowPopUp(true)
  };
  return (
    <div className="section">
      {loading && <Loader />}
      <Modals show={showPopUp} onHide={hideHandler}>
        <Row className="g-3">
          <h5>Add Sub-Topic</h5>
          <Col sm={12}>
            <Form.Label>Subject</Form.Label>
            <Select value={modalSelectedSub} onChange={modalSubSelector}>
              <option value="" disabled>
                Select Subject
              </option>
              {subjectList.map((data) => {
                return <option value={data.sub_id}>{data.sub_name}</option>;
              })}
            </Select>
          </Col>
          <Col sm={12}>
            <Form.Label>Topic</Form.Label>
            <Select value={addModalData.topic_id} onChange={e => setAddModalData(prev => {
              return {
                ...prev,
                topic_id: e.target.value
              }
            })}>
              <option value="" disabled>
                Select Topic
              </option>
              {modalTopicList.map((data) => {
                return <option value={data.topic_id}>{data.topic_name}</option>;
              })}
            </Select>
          </Col>
          <Col sm={12}>
            <Form.Label>Sub-Topic Name :</Form.Label>
            <Input type="text" placeholder="Enter Sub-topic Name" value={addModalData.sub_topic_name} onChange={e => setAddModalData(prev => {
              return {
                ...prev,
                sub_topic_name: e.target.value
              }
            })} />
          </Col>
          <Col sm={12}>
            <Form.Label>Sub-Topic Sequence :</Form.Label>
            <Input type="number" placeholder="Enter Topic Sequence" value={addModalData.sub_topic_sequence} onChange={e => setAddModalData(prev => {
              return {
                ...prev,
                sub_topic_sequence: e.target.value
              }
            })}
            />
          </Col>
        </Row>
        <div className="text-center mt-5 mb-3">
          <SecBTN className="sec-btn1" onClick={onAddSubTopic}>
            Add Sub-Topic
          </SecBTN>
        </div>
      </Modals>
      <Toast />
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h4>Edit Sub-Topic</h4>
          <Breadcrumb>
            {/*<Breadcrumb.Item><Link to='/'> Home </Link></Breadcrumb.Item>*/}
            <Breadcrumb.Item active>Edit Sub-Topic</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <SecBTN className="sec-btn" onClick={addSubTopicPopup}>
          Add Sub-Topic
        </SecBTN>
      </div>
      <Graybg>
        <Card className="mb-4">
          <Row className="align-items-end">
            <Col md={3}>
              <Form.Label>Subject :</Form.Label>
              <Select
                value={selectedSubject}
                onChange={selectSubHandler}
              >
                <option value="">Select Subject</option>
                {subjectList.map((data) => (
                  <option key={data.sub_id} value={data.sub_id}>
                    {data.sub_name}
                  </option>
                ))}
              </Select>
            </Col>

            <Col md={3}>
              <Form.Label>Topic :</Form.Label>
              <Select
                value={selectedTopic}
                onChange={selectTopicHandler}
                disabled={!selectedSubject}
              >
                <option value="">Select Topic</option>
                {topicList.map((data) => (
                  <option key={data.topic_id} value={data.topic_id}>
                    {data.topic_name}
                  </option>
                ))}
              </Select>
            </Col>

            <Col md={3}>
              <Form.Label>Status :</Form.Label>
              <Select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="">All</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </Select>
            </Col>

            <Col md={3}>
              <SecBTN
                className="sec-btn w-100 mb-2"
                onClick={searchHandler}
              >
                Search
              </SecBTN>
            </Col>
          </Row>
        </Card>
        <DataTable
          data={subTopicList}
          noDataShow={noData}
          updateHandler={updateHandler}
          activationHandler={activationHandler}
          sub={selectedSubject}
        />
      </Graybg>
    </div>
  );
};

export default EditSubTopic;
